import styled from 'styled-components';
import { rem } from '@/styles/theme';

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  padding-top ${rem(32)};
`;
